import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { CreatebulkuserPage } from './createbulkuser.page';

const routes: Routes = [
  {
    path: '',
    component: CreatebulkuserPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CreatebulkuserPageRoutingModule {}
